import * as t from "io-ts";
import { withFallback } from "io-ts-types";
export const webBookerLanguageT = t.union([
    t.literal("da"),
    t.literal("en"),
    t.literal("fi"),
]);
export const webBookerSettingsT = t.strict({
    language: withFallback(webBookerLanguageT, "da"),
});
export const setWebBookerLanguageReqT = t.strict({
    value: webBookerLanguageT,
});
//# sourceMappingURL=web-booking-settings.js.map